export interface Office {
  id: string
  city: string
  isHq: boolean
  address: string
  phone: string
  email: string
  hours: string
}

export const offices: Office[] = [
  {
    id: 'rj',
    city: 'Rio de Janeiro, RJ',
    isHq: true,
    address: 'Avenida Carlos Meziano, 482, Portuguesa, Rio de Janeiro, RJ',
    phone: '(21) 97226-5440',
    email: 'comercial@frm.net.br',
    hours: 'Seg. a Sex., 8h às 18h',
  },
]
